/* 🤖 this file was generated by script */
export const wsolidiconScales01 = {
  name: 'scales_01',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M13 3a1 1 0 0 0-2 0v4.15l-5.15.86a1 1 0 0 0-.72.5l-3.6 6.3q-.2.33-.33.65a3 3 0 0 0-.16.6q-.05.35-.04.74v.2a5 5 0 0 0 10 0v-.25q.01-.37-.04-.68a3 3 0 0 0-.49-1.26L7.58 9.75l8.5-1.42-2.55 4.48q-.2.33-.33.65a3 3 0 0 0-.16.6q-.05.35-.04.74v.2a5 5 0 0 0 10 0v-.26q.01-.36-.04-.67a3 3 0 0 0-.49-1.26l-3.6-6.29A1 1 0 0 0 18 6l-.18.02-4.82.8zm7.28 10L18 9.02 15.72 13zm-12 2L6 11.02 3.72 15z" clip-rule="evenodd"/></svg>`,
  iconStyle: 'solid',
};
